

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Nullable } from '@/types/general'

@Component({ name: 'v-validation-error' })
export default class VValidationError extends Vue {
    boundingRect: Nullable<ClientRect | DOMRect> = null

    @Prop({ type: String, required: true })
    target!: string

    @Watch('target')
    updateRect(newTarget: string) {
        const $el = document.querySelector(this.target)
        if ($el) {
            this.boundingRect = $el.getBoundingClientRect()
        }
    }

    mounted(): void {
        this.updateRect(this.target)
        window.addEventListener('resize', this.resize)
    }

    destroyed(): void {
        window.removeEventListener('resize', this.resize)
    }

    resize(): void {
        this.updateRect(this.target)
    }

    get x(): number {
        if (!this.boundingRect) {
            return -2000
        }
        return this.boundingRect.left
    }

    get y(): number {
        if (!this.boundingRect) {
            return -2000
        }
        return this.boundingRect.bottom
    }
}
